import React, { FC, ReactNode } from 'react';

import styled from '@emotion/styled';
import {
  compose,
  layout,
  space,
  background,
  shadow,
  border,
  color,
  grid,
  flexbox,
  position,
  display,
  variant,
} from '@lucid/theme';

import { LucidTheme, Component } from '../../types/types';
import Box from '../box/box';
import WaveSVG from './wave-svg';

export interface WaveProps {
  /** The children of the Paper component. */
  children: ReactNode;
  /** Allows the component to get additional styles. */
  className?: string;
  /** Sets the wave to be on the bottom. */
  hasBottomWave?: boolean;
  /** The available variants for the Wave component. */
  variant?: Component.Type['Wave'];
}

const waveStyles = compose(background, shadow, border, color, grid, space, flexbox, layout, position, display);

const StyledWave = styled.div<WaveProps>(
  variant({
    scale: 'wave',
    variants: {
      defaultVariant: {},
    },
  }),
  {
    label: 'wave',
    width: '100%',
  },
  waveStyles,
);

const Wave: FC<WaveProps> = ({ children, className, hasBottomWave, variant = 'default', ...rest }) => (
  <StyledWave {...rest} className={className} variant={variant}>
    <Box css={{ height: 'auto', width: '100%' }}>
      <WaveSVG
        css={(theme: LucidTheme) => ({
          path: {
            fill: theme.colors.primary,
          },
          display: 'block',
          width: '100%',
        })}
      />
    </Box>
    <Box className="waveChildrenContainer">{children}</Box>
    {hasBottomWave && (
      <Box css={{ height: 'auto', width: '100%' }}>
        <WaveSVG
          css={(theme: LucidTheme) => ({
            path: {
              fill: theme.colors.primary,
            },
            display: 'block',
            width: '100%',
            marginTop: -1,
            transform: 'scaleY(-1) scaleX(-1)',
          })}
        />
      </Box>
    )}
  </StyledWave>
);

export { Wave };
export default Wave;
